import { useEffect } from "react";

import Contacts from "../../../../components/modules/contacts/Contacts";
import Navigation from "../../../../components/navigations/client/detail/navigation";
import useParentLoaderData from "../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../services/navigation-history-service";

export default function ContatcTemplate() {
  // Dot colors come from the parent loader rather than a fetch of our own: the two routes
  // load in parallel and a second contact-type query here would race the parent's over the
  // store slot they'd share.
  const { _case, contactTypeColors } = useParentLoaderData(1);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/contacts");
  }, []);

  return (
    <Navigation activeTab="contacts" _case={_case}>
      <div className="min-h-[90vh] overflow-y-auto rounded-b-[15px] bg-white p-4">
        <Contacts caseObj={_case} contactTypeColors={contactTypeColors} />
      </div>
    </Navigation>
  );
}
